<template>
  <view-with-location :isDisabled="true">

    <v-container v-if="isMobile && order && order.agreementId && orderWasteType" class="pt-4 history-detail-mobile">
      <v-container class="text-center px-0 pb-1" style="width: 100%; overflow-y: auto">
        <v-row no-gutters class="mt-0 mb-0 pr-2" align="end" justify="end">
          <v-icon
          color="primary"
          style="text-align: right; font-size: 1.25rem"
          @click="clickEditOrder"
          :disabled="order.orderStatus.id !== 1 || umleerBehalters.includes(order.agreement.containerTypeId) || terminTomorrowItsAfternoon"
          >mdi-pencil-outline</v-icon
        >
        </v-row>
        <v-row no-gutters class="mt-0 mb-1" align="center" justify="center" >
          <v-avatar color="warning" size="80px">
          <v-img :src="orderWasteType.imageSmall" />
        </v-avatar>
        <v-container class="ma-0 pa-0 pt-2 mb-3" style="font-size: 1.15rem !important">
          <strong>{{ orderWasteType.description }}</strong>
        </v-container>
        <v-btn
          v-if="order.orderStatus.id === 1 || order.orderStatus.id === 3"
          class="mt-0 pt-0 mb-3"
          color="primary"
          @click="completeThisOrder"
          min-width="70%"
          min-height="45px"
          rounded
          depressed
          >Auf erledigt setzen</v-btn
        >
        </v-row>

        <v-divider />
      </v-container>
      <v-card flat class="pb-3 mb-16">
        <v-card-text
          class="justified-list pa-0"
          style="
            width: 94% !important;
            margin-left: 3% !important;
            font-size: 1rem !important;
            min-height: 40px !important;
            vertical-align: middle;
            line-height: 40px !important;
          "
        >
          <v-col
            class="pa-0"
            cols="4"
            style="
              font-weight: bold !important;
              display: inline-flex !important;
              color: black !important;
              text-transform: capitalize;
              vertical-align: middle;
            "
            ><v-icon
              v-if="order.orderStatus.id === 3"
              style="color: #f9c07f !important; padding-top: 0 !important"
              >mdi-alert</v-icon
            >{{ order.orderStatus.id === 3 ? " Offen" : order.orderStatus.description }}
          </v-col>
          <v-col
            class="pa-0"
            cols="8"
            style="
              font-weight: bold !important;
              color: black !important;
              display: inline-grid !important;
              text-align: right;
              vertical-align: middle;
            "
            ><div>gepl. am: {{ format(order.desiredDate) }}</div>
          </v-col>
        </v-card-text>
        <v-divider />
        <justified-list
          class="history-justified-list"
          labelName="Abfallart"
          :itemValue="orderWasteType.description"
          :isSmallDevice="true"
        />
        <v-divider />
        <justified-list
          class="history-justified-list"
          labelName="Behälter"
          :itemValue="containerTypeAndSize"
          :isSmallDevice="true"
        />
        <v-divider />
        <justified-list
          class="history-justified-list"
          labelName="Anzahl"
          :itemValue="order.amount.toString()"
          :isSmallDevice="true"
        />
        <v-divider />
        <justified-list
          class="history-justified-list"
          labelName="Aktion"
          :itemValue="order.containerAction.description"
          :isSmallDevice="true"
        />
        <v-divider />
        <justified-list
          class="history-justified-list"
          labelName="Auftragsart"
          :itemValue="`${agreementTypeLabel}${showTurnusInfo}`"
          :isSmallDevice="true"
        />
        <v-divider />
        <justified-list
          class="history-justified-list"
          labelName="Auftrags-Nr."
          :itemValue="showCorrectOrderId"
          :isSmallDevice="true"
        />
        <v-divider />
        <justified-list
          class="history-justified-list"
          labelName="Hinweis für den Entsorger"
          :itemValue="order.hint"
          :isSmallDevice="true"
        />
        <v-divider />
        <v-card-text
          class="justified-list pa-0 mt-0"
          style="
            width: 94% !important;
            margin-left: 3% !important;
            min-height: 40px !important;
            font-size: 1rem !important;
            line-height: 40px !important;
          "
        >
          <v-col
            class="pa-0"
            cols="6"
            style="
              font-weight: bold !important;
              display: inline-flex !important;
              color: black !important;
              text-transform: capitalize;
              vertical-align: middle;
            "
            >Standort
          </v-col>
        </v-card-text>
        <v-divider />
        <justified-list
          class="history-justified-list"
          labelName="Standort Bez."
          :itemValue="serviceLocationName"
          :isSmallDevice="true"
        />
        <v-divider />
        <justified-list
          class="history-justified-list"
          labelName="Adresse"
          :itemValue="serviceAddress"
          :isSmallDevice="true"
        />
        <v-divider />
        <v-card-text
          class="justified-list pa-0 mt-0"
          style="
            width: 94% !important;
            margin-left: 3% !important;
            min-height: 40px !important;
            font-size: 1rem !important;
            line-height: 40px !important;
          "
        >
          <v-col
            class="pa-0"
            cols="6"
            style="
              font-weight: bold !important;
              display: inline-flex !important;
              color: black !important;
              text-transform: capitalize;
              vertical-align: middle;
            "
            >Historie
          </v-col>
        </v-card-text>
        <div class="history-entry">
          <v-divider />
          <justified-list
            class="history-justified-list"
            labelName="Beauftragt am"
            :itemValue="format(order.createdOn)"
            :isSmallDevice="true"
          />
          <justified-list
            class="history-justified-list"
            labelName="Beauftragt von"
            :itemValue="order.createdByUser.firstName + ' ' + order.createdByUser.lastName"
            :isSmallDevice="true"
          />
        </div>
        <div v-for="claim in order.claims" :key="claim.createdOn" class="history-entry">
          <v-divider />
          <justified-list
            class="history-justified-list"
            labelName="Reklamiert am"
            :itemValue="format(claim.createdOn)"
            :isSmallDevice="true"
          />
          <justified-list
            class="history-justified-list"
            labelName="Reklamiert von"
            :itemValue="claim.createdByUser.firstName + ' ' + claim.createdByUser.lastName"
            :isSmallDevice="true"
          />
          <justified-list
            class="history-justified-list"
            labelName="Reklamationsgrund"
            :itemValue="claim.userInputReason || claim.claimReason.description"
            :isSmallDevice="true"
          />
        </div>
        <div v-if="order.orderStatus.id === 4" class="history-entry">
          <v-divider />
          <justified-list
            class="history-justified-list"
            labelName="Storniert am"
            :itemValue="format(order.changedOn)"
            :isSmallDevice="true"
          />
          <justified-list
            class="history-justified-list"
            labelName="Storniert von"
            :itemValue="order.changedByUser.firstName + ' ' + order.changedByUser.lastName"
            :isSmallDevice="true"
          />
          <justified-list
            class="history-justified-list"
            labelName="Stornogrund"
            :itemValue="order.cancellation.cancellationReason.description"
            :isSmallDevice="true"
          />
        </div>
        <v-divider v-if="order.orderStatus.id !== 1" />
        <v-card-actions
          class="pt-6 pb-0 px-3"
          v-if="order.orderStatus.id !== 2 && order.orderStatus.id !== 4"
        >
          <v-btn
            color="primary"
            min-width="47%"
            outlined
            @click="claimDialog = true"
            rounded
            >Reklamieren</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="primary" min-width="47%" outlined @click="cancelDialog = true" rounded
            >Stornieren</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-container>

    <v-container v-if="!isMobile && order && order.agreementId && orderWasteType" class="pt-4 history-detail-desktop">
      <div class="action-buttons" v-if="order.orderStatus.id === 1 || order.orderStatus.id === 3">
        <v-btn color="primary" @click="claimDialog = true" outlined rounded
          >Reklamieren</v-btn
        >
        <v-btn color="primary" @click="cancelDialog = true" outlined rounded
          >Stornieren</v-btn
        >
        <v-btn
          v-if="order.orderStatus.id === 1 || order.orderStatus.id === 3"
          class="mt-0 pt-0"
          color="primary"
          @click="completeThisOrder"
          rounded
          depressed
          >Erledigen</v-btn
        >
      </div>
      <v-col class="detail-cards">
        <v-card flat class="left-card">
          <v-container class="px-0 pb-1" style="width: 100%;">
            <v-row no-gutters class="mt-0 ml-4 mr-4">
              <v-col
                class="pa-0 pt-4 pb-2 card-heading"
                >Auftrag
                  <v-chip
                  :class="statusColorClass"
                  class="special-vchip ml-6"
                  text-color="white"
                  data-cy="order-description"
                  >{{ order.orderStatus.description }}
                </v-chip>
              </v-col>
              <v-col class="pa-0 pt-4 pb-2 card-heading" style="text-align: right; margin-right: 3% !important">
                <v-icon
                  color="primary"
                  style="text-align: right; font-size: 1.25rem"
                  @click="clickEditOrder"
                  :disabled="order.orderStatus.id !== 1 || umleerBehalters.includes(order.agreement.containerTypeId) || terminTomorrowItsAfternoon"
                  >mdi-pencil-outline</v-icon
                >
              </v-col>
            </v-row>
            <v-divider />
            <v-row class="ma-0 pt-2 high-line">
              <v-col cols="8" class="column-items">
                <div style="display: inline-flex" class="pa-0 full-width">
                  <v-card-text
                    class="pa-0 card-text-left-headings"
                  >
                    Wunschtermin
                    </v-card-text>
                    <v-card-text class="pa-0">
                      {{ format(order.desiredDate) }}
                  </v-card-text>
                </div>

                <div style="display: inline-flex" class="pa-0 full-width">
                  <v-card-text
                    class="pa-0 card-text-left-headings"
                  >
                    Abfallart
                    </v-card-text>
                    <v-card-text class="pa-0">
                      {{ orderWasteType.description }}
                  </v-card-text>
                </div>
                <div style="display: inline-flex" class="pa-0 full-width">
                  <v-card-text
                    class="pa-0 card-text-left-headings"
                  >
                    Behälter
                    </v-card-text>
                    <v-card-text class="pa-0">
                      {{ containerTypeAndSize }}
                  </v-card-text>
                </div>
                <div style="display: inline-flex" class="pa-0 full-width">
                  <v-card-text
                    class="pa-0 card-text-left-headings"
                  >
                    Anzahl
                    </v-card-text>
                    <v-card-text class="pa-0">
                      {{ order.amount.toString() }}
                  </v-card-text>
                </div>
                <div style="display: inline-flex" class="pa-0 full-width">
                  <v-card-text
                    class="pa-0 card-text-left-headings"
                  >
                    Aktion
                    </v-card-text>
                    <v-card-text class="pa-0">
                      {{ order.containerAction.description }}
                  </v-card-text>
                </div>
                <div style="display: inline-flex" class="pa-0 full-width">
                  <v-card-text
                    class="pa-0 card-text-left-headings"
                  >
                    Auftragsart
                    </v-card-text>
                    <v-card-text class="pa-0">
                      {{ agreementTypeLabel + showTurnusInfo }}
                  </v-card-text>
                </div>
                <div style="display: inline-flex" class="pa-0 full-width">
                  <v-card-text
                    class="pa-0 card-text-left-headings"
                  >
                    Auftrags-Nr.
                    </v-card-text>
                    <v-card-text class="pa-0">
                      {{ showCorrectOrderId }}
                    </v-card-text>
                </div>
                <div style="display: inline-flex" class="pa-0 full-width">
                  <v-card-text
                    class="pa-0 card-text-left-headings"
                  >
                    Hinweis für den Entsorger
                    </v-card-text>
                    <v-card-text class="pa-0">
                      {{ order.hint }}
                  </v-card-text>
                </div>
              </v-col>
              <v-col
                cols="4"
              >
                <v-avatar color="warning" class="mt-4 mr-2 mx-auto waste-type-image">
                  <v-img :src="orderWasteType.imageSmall" />
                </v-avatar>
              </v-col>
            </v-row>


            <v-card-text
            class="pa-0 mt-0"
            style="
              min-height: 40px !important;
              font-size: 1rem !important;
              line-height: 40px !important;
            "
            >
            <v-col
              class="pa-0 pt-8 card-heading"
              >Standort
            </v-col>
            <v-divider />
            <v-col class="column-items">
              <div style="display: inline-flex" class="pa-0 full-width">
                <v-card-text
                  class="pa-0 card-text-left-headings"
                >
                  Standort Bez.
                </v-card-text>
                <v-card-text class="pa-0">
                  {{ serviceLocationName }}
                </v-card-text>
              </div>
              <div style="display: inline-flex" class="pa-0 full-width">
                <v-card-text
                  class="pa-0 card-text-left-headings"
                >
                  Leistungsadrese
                </v-card-text>
                <v-card-text class="pa-0">
                  {{ serviceAddress }}
                </v-card-text>
              </div>
            </v-col>
            </v-card-text>
          </v-container>
        </v-card>
        <v-card flat class="right-card">
          <v-card-text
            class="pa-0 mt-0"
            style="
              margin-left: 3% !important;
              font-size: 1rem !important;
            "
          >
            <v-col
              class="pa-0 pt-8 pb-3 card-heading"
              >Historie
            </v-col>

            <v-divider class="history-divider" />
            <div class="history-entry">
              <v-col class="column-items">
                <div style="display: inline-flex" class="pa-0 full-width">
                  <v-card-text
                    class="pa-0 card-text-left-headings"
                  >
                    Beauftragt am
                  </v-card-text>
                  <v-card-text class="pa-0">
                    {{ format(order.createdOn) }}</v-card-text>
                </div>
                <div style="display: inline-flex" class="pa-0 full-width">
                  <v-card-text
                    class="pa-0 card-text-left-headings"
                  >
                    Beauftragt von
                  </v-card-text>
                  <v-card-text class="pa-0">{{
                    order.createdByUser.firstName +
                    ' ' +
                    order.createdByUser.lastName
                  }}</v-card-text>
                </div>
              </v-col>
            </div>

            <div v-for="claim in order.claims" :key="claim.createdOn" class="history-entry">
              <v-col class="column-items">
                <div style="display: inline-flex" class="pa-0 full-width">
                  <v-card-text
                    class="pa-0 card-text-left-headings"
                  >
                    Reklamiert am
                  </v-card-text>
                  <v-card-text class="pa-0">{{
                    format(claim.createdOn)
                  }}</v-card-text>
                </div>
                <div style="display: inline-flex" class="pa-0 full-width">
                  <v-card-text
                    class="pa-0 card-text-left-headings"
                  >
                    Reklamiert von
                  </v-card-text>
                  <v-card-text class="pa-0">{{
                    claim.createdByUser.firstName +
                    ' ' +
                    claim.createdByUser.lastName
                  }}</v-card-text>
                </div>
                <div style="display: inline-flex" class="pa-0 full-width">
                  <v-card-text
                    class="pa-0 card-text-left-headings"
                  >
                    Reklamationsgrund
                  </v-card-text>
                  <v-card-text class="pa-0">{{
                    claim.userInputReason || claim.claimReason.description
                  }}</v-card-text>
                </div>
              </v-col>
            </div>
            <div v-if="order.orderStatus.id === 4" class="history-entry">
              <v-col class="column-items">
                  <div style="display: inline-flex" class="pa-0 full-width">
                    <v-card-text
                      class="pa-0 card-text-left-headings"
                    >
                      Storniert am
                    </v-card-text>
                    <v-card-text class="pa-0">{{
                      format(order.changedOn)
                    }}</v-card-text>
                  </div>
                  <div style="display: inline-flex" class="pa-0 full-width">
                    <v-card-text
                      class="pa-0 card-text-left-headings"
                    >
                      Storniert von
                    </v-card-text>
                    <v-card-text class="pa-0">{{
                      order.changedByUser.firstName + ' ' + order.changedByUser.lastName
                    }}</v-card-text>
                  </div>
                  <div style="display: inline-flex" class="pa-0 full-width">
                    <v-card-text
                      class="pa-0 card-text-left-headings"
                    >
                      Stornogrund
                    </v-card-text>
                    <v-card-text class="pa-0">{{
                      order.cancellation.cancellationReason.description
                    }}</v-card-text>
                  </div>
              </v-col>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-container>

    <v-container v-if="order === undefined">
      Bitte wählen Sie zunächst einen Auftrag.
    </v-container>

    <cancel-dialog
      v-model="cancelDialog"
      :orderId="id"
      @hide-dialog="cancelDialog=false"
      @refresh-history="badMethodBecauseHistoryListDoesNotUseStore()"
    />

    <claim-dialog
      v-model="claimDialog"
      :orderId="id"
      @hide-dialog="claimDialog=false"
      @refresh-history="badMethodBecauseHistoryListDoesNotUseStore()"
    />

    <v-dialog
      v-model="editOrderDialog"
      max-width="500"
      v-if="!isMobile"
      style="overflow: hidden !important"
      persistent
    >
      <order-detail-edit
        :order="order"
        :key="dialogKey"
        :subComponentKey="dialogKey"
        @close-edit-dialog="closeAllDialog"
        @success-edit-dialog="actionSuccessCloseDialogs"
      />
    </v-dialog>
    <v-bottom-sheet v-model="editOrderDialog" max-width="500" v-if="isMobile">
      <order-detail-edit
        :order="order"
        :key="dialogKey"
        :subComponentKey="dialogKey"
        @close-edit-dialog="closeAllDialog"
        @success-edit-dialog="actionSuccessCloseDialogs"
      />
    </v-bottom-sheet>
  </view-with-location>
</template>
<script>
import Vue from "vue";
import ViewWithLocation from "@/components/ViewWithLocation.vue";
import JustifiedList from "@/components/atoms/JustifiedList.vue";
import CancelDialog from "@/components/order/CancelDialog";
import ClaimDialog from "@/components/order/ClaimDialog.vue";
import OrderDetailEdit from "@/components/OrderDetailEdit.vue";
import { dateFormat, ContainerType } from "@/helpers";

export default Vue.extend({
  props: {
    id: String,
  },
  components: {
    ViewWithLocation,
    JustifiedList,
    CancelDialog,
    ClaimDialog,
    OrderDetailEdit
  },
  data() {
    return {
      cancelDialog: false,
      claimDialog: false,
      editOrderDialog: false,
      dialogKey: 0
    };
  },
  mounted() {
    this.$store.dispatch("getOrder", this.id);
    this.$store.dispatch("getTypesForAgreement");
  },
  watch: {
    editOrderDialog: function(value) {
      if (value !== false) {
        this.dialogKey += 1;
      }
    }
  },
  computed: {
    order() {
      return this.$store.getters.order;
    },
    typesForAgreement() {
      return this.$store.getters.typesForAgreement;
    },
    orderWasteType () {
      let wasteType;
      if(this.order.independentWasteTypeId !== 0) {
        wasteType = this.typesForAgreement.wasteTypes.filter(w => w.id === this.order.independentWasteTypeId)[0];
      } else {
        wasteType = this.order.agreement.wasteType;
      }
      return wasteType;
    },
    containerTypeAndSize() {
      const containerExtra =
        this.order.agreement.containerType.extra &&
        this.order.agreement.containerType.extra !== ""
          ? ", " + this.order.agreement.containerType.extra
          : "";
      const containerSize =
        this.order.agreement.containerType.size &&
        this.order.agreement.containerType.size !== ""
          ? ", " + this.order.agreement.containerType.size
          : "";
      return this.order.agreement.containerType.type + containerExtra + containerSize;
    },
    agreementTypeLabel() {
      switch (this.order.agreement.agreementTypeId) {
        case 2: // Sofortbefüllung Type
          return "Sofortbefüllung";
        case 3: // Abruf Type
          return "Dauerauftrag a. Abruf";
        case 4: // Turnus Type
          return "Turnus";
        default:
          return "#Abruf";
      }
    },
    showTurnusInfo() {
      if (this.order.agreement.agreementTypeId === 4) {
        if (this.order.selectedInterval === '2x pro Woche') {
          return ', ' + this.order.selectedInterval + ', ' + this.order.selectedFirstDay + ' & ' +this.order.selectedSecondDay;
        }
        return ', ' + this.order.selectedInterval + ', ' + this.order.selectedFirstDay;
      }
      return '';
    },
    serviceLocationName() {
      return this.$store.getters.location.alias;
    },
    serviceAddress() {
      return `${this.$store.getters.location.street} ${this.$store.getters.location.houseNumber}, ${this.$store.getters.location.zip} ${this.$store.getters.location.city}`;
    },
    locationActive() {
      return this.$store.getters.location.active;
    },
    serviceSystemId() {
      return this.$store.getters.location.externalSystemId;
    },
    isMobile() {
      return this.$vuetify.breakpoint.width < 768;
    },
    statusColorClass() {
      switch (this.order.orderStatusId) {
        case 3: // reklamiert
          return "color-claim";
        case 4: // storniert
          return "color-cancel";
        case 2: // erledigt
          return "color-complete";
        default:
          return "color-open";
      }
    },
    showCorrectOrderId() {
      if (this.order.externalOrderId === '' || this.order.externalOrderId === null) {
        return this.order.orderId;
      } else {
        return this.order.externalOrderId;
      }
    },
    umleerBehalters() {
      return ContainerType.UMLEER_BEHALTER;
    },
    terminTomorrowItsAfternoon(){
      const today = new Date();
      const termin = new Date(`${this.order.desiredDate}T00:00:00`);
      const timeDiff = Math.abs(termin.getTime() - today.getTime());
      const diffDays = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
      return diffDays < 2 && today.getHours() >= 12;
    }
  },
  methods: {
    badMethodBecauseHistoryListDoesNotUseStore() {
      // when order is cancelled, we can not directly navigate to history, because cancelling the order takes time
      window.setTimeout(() => {
        this.$router.push('/order-history')
      }, 1000)
    },
    format(str) {
      return dateFormat(str);
    },
    completeThisOrder() {
      this.$store
        .dispatch("resolveOrder", this.order.orderId)
        .then(() => {
          this.$toast("Der Auftrag wurde als erledigt markiert.", {
            timeout: 5000,
          });
          if (this.$cookies.isAccepted()){
            this.$gtag.event('order-resolve', {
              'event_category': 'order'
            })
          }
        })
        .catch((e) => {
          this.$toast.error(e.response.data.error.message);
        });
      this.badMethodBecauseHistoryListDoesNotUseStore();
    },
    clickEditOrder() {
      this.editOrderDialog = true;
    },
    closeAllDialog() {
      this.editOrderDialog = false;
    },
    actionSuccessCloseDialogs() {
      this.$store.dispatch("getOrder", this.id).then(() => {
        this.editOrderDialog = false;
      });
    },
  },
});
</script>
<style scoped>
.mobile-history .v-chip__content * {
  padding: 0 !important;
}
.history-justified-list >>> * {
  font-weight: normal !important;
}
@media (min-width: 600px) {
  .history-detail-mobile {
    max-width: 60% !important;
  }
}
.history-entry {
  padding: 0 0 10px 0 !important;
}

.history-entry .v-divider {
  margin: 0 0 10px 0 !important;
}

.history-entry .history-justified-list {
  line-height: 25px !important;
  min-height: 20px !important;
}

.history-entry-mobile .history-justified-list {
  line-height: 25px !important;
  min-height: 20px !important;
}
.history-detail-desktop .action-buttons {
  float: right;
  padding-right: 12px;
}
.history-detail-desktop .action-buttons .v-btn{
  min-height: 40px !important;
  width: 150px !important;
  font-weight: 500 !important;
  margin: 0 5px 30px;
}
.history-detail-desktop .detail-cards {
  display: flex;
  justify-content: space-between;
}
.history-detail-desktop .left-card {
  width: 65%;
}
.history-detail-desktop .right-card {
  width: 33%;
}
.history-detail-desktop .right-card .v-card__text {
  color: rgba(0, 0, 0, 0.87) !important;
}
.history-detail-desktop .right-card .history-divider {
  width: 88% !important;
}
.history-detail-desktop .high-line {
  line-height: 35px;
}
.history-detail-desktop .full-width {
  width: 100%;
}
.history-detail-desktop .card-text-left-headings {
  font-weight: 500;
  max-width: 180px !important;
}
.history-detail-desktop .column-items {
  padding-left: 3% !important;
}
.history-detail-desktop .card-heading {
  margin-left: 3% !important;
  color: black !important;
  font-weight: bold !important;
  text-transform: capitalize;
}
.history-detail-desktop .history-entry {
  line-height: 25px !important;
}
.history-detail-desktop .v-divider {
  width: 94% !important;
  margin-left: 3% !important;
  margin-top: 12px !important;
}

.history-detail-desktop .waste-type-image {
  width: 70% !important;
  height: auto !important;
}
.color-open {
  background: #00B791 !important;
}
.color-complete {
  background: #44d68d !important;
}
.color-claim {
  background: #f9c07f !important;
}
.color-cancel {
  background: #f58686 !important;
}
</style>
